import * as React from 'react';

interface NavigationRegionProps {
  className: string;
}

export class NavigationRegion extends React.Component<NavigationRegionProps> {
  public render() {
    const classes = ['navigation-region', this.props.className].filter(val => val).join(' ');

    return <section className={classes}>{this.props.children}</section>;
  }
}
